// src/components/MainPanel/NoteEditorContainer.js
import React, { forwardRef, useImperativeHandle } from 'react';
import NoteViewMain from './NoteViewMain';
import { useCategories } from '../contexts/CategoriesContext';
import useNoteEditor from '../../hooks/useNoteEditor';

const NoteEditorContainer = forwardRef(({ 
  isImageUploadExpanded,
  onImagePaste,
  onToggleImageUpload,
  onImageUpload
}, ref) => {
  const { categories } = useCategories();
  
  // Use our new custom hook
  const {
    note,
    isLoading,
    noteId,
    images,
    imagesRef,
    handleNoteChange,
    handleTitleChange,
    handleCategoryChange
  } = useNoteEditor({ onImageUpload });

  // Forward the ref
  useImperativeHandle(ref, () => ({
    refreshImages: imagesRef.current.refreshImages,
    images: imagesRef.current.images
  }), [imagesRef]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!note) {
    return <div>No note selected</div>;
  }

  return (
    <NoteViewMain
      ref={ref}
      noteId={noteId}
      note={note}
      categories={categories}
      onNoteChange={handleNoteChange}
      onTitleChange={handleTitleChange}
      onCategoryChange={handleCategoryChange}
      isImageUploadExpanded={isImageUploadExpanded}
      onToggleImageUpload={onToggleImageUpload}
      onImagePaste={onImagePaste}
      onImageUpload={onImageUpload}
      images={images}
    />
  );
});

export default NoteEditorContainer;